import { render, staticRenderFns } from "./Prdtype_mgt.vue?vue&type=template&id=14779b58&"
import script from "./Prdtype_mgt.vue?vue&type=script&lang=js&"
export * from "./Prdtype_mgt.vue?vue&type=script&lang=js&"
import style0 from "./Prdtype_mgt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports